var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.8a.8.8 0 00-.8-.8H7.831a.8.8 0 01-.565-.234L6.234 2.734A.8.8 0 005.67 2.5H2.3a.8.8 0 00-.8.8v9.4a.8.8 0 00.8.8h11.4a.8.8 0 00.8-.8V4.8z",
    stroke: "#4c6aff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.218 8.89h5.564M8 11.668V6.112",
    stroke: "#4c6aff",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/add_folder.64788c67.svg";
export { SvgAddFolder as ReactComponent };